import { Flex, Tag } from "@chakra-ui/react";

interface TagsRendererProps {
  tagsList: Array<string>;
}

const TagsRenderer = ({ tagsList }: TagsRendererProps) => {
  return (
    <Flex maxW="100%" flexWrap="wrap" gap="2px">
      {tagsList.map((tag: string) => (
        <Tag
          key={tag}
          bg="#C1DDF2"
          color="#577A95"
          fontSize="12px"
          fontWeight="500"
          letterSpacing="normal"
          p="6px 10px"
          borderRadius="6px"
        >
          {tag}
        </Tag>
      ))}
    </Flex>
  );
};

export default TagsRenderer;
